const ActionType = {
  DOCUMENT_LOADING: "DocumentAction.DOCUMENT_LOADING",
  DOCUMENT_ERROR: "DocumentAction.DOCUMENT_ERROR",
  DOCUMENT_SUCCESS: "DocumentAction.DOCUMENT_SUCCESS",
  DOCUMENT_DATA: "DocumentAction.DOCUMENT_DATA",
};

export default ActionType;